jQuery( document ).ready( function($) {

	// slick slider
	$( '.slide-banner' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: true,
		dots: true,
		arrows: true,
		appendDots: $( '.page-slider-nav' )
	});

	$( '.slide-rooms' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: true,
		arrows: true
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( '.navigation' ).toggleClass( 'slidein' );
		$( 'body' ).toggleClass( 'noscroll' );
		$( '.page-overlay' ).toggleClass( 'show' );
	});

	// add arrow to dropdown menu items
	$( '.menu-item-has-children' ).prepend( '<span></span>' );

	// toggle the sub menu
	$( '.menu-item-has-children' ).on( 'click', 'span', function(e) {
		$( this ).closest( 'li' ).find( '.submenu' ).toggleClass( 'shown' );
	});

});